import { render, staticRenderFns } from "./AnnuityForm.vue?vue&type=template&id=33c47fcb&"
import script from "./AnnuityForm.vue?vue&type=script&lang=js&"
export * from "./AnnuityForm.vue?vue&type=script&lang=js&"
import style0 from "./AnnuityForm.vue?vue&type=style&index=0&id=33c47fcb&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports